// Code to fade text out of frontpgage hero image text after 20s
// See also _frontpage.scss
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    document.querySelector(".block-inline-blockhero")?.classList.add("fade-out");
  } , 20000);
});
